
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/builds/robustastudio/midea/miraco-website/sentry.client.config.ts")
            }
          });